import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '../../../../../environments/environment';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-new-client-modal',
  templateUrl: './new-client-modal.component.html',
  styleUrls: ['./new-client-modal.component.scss']
})


export class NewClientModalComponent {
  public realDeskForm: FormGroup;
  public isLoading:boolean = false;

  constructor(private fb: FormBuilder, private modal: NgbActiveModal, public router: Router, private http: HttpClient) {
    this.realDeskForm = this.fb.group(
      {
        nome: ["", Validators.required],
        email: [""], // Sem Validators.required
        telefone: [""], // Sem Validators.required
      },
      { validators: this.requireAtLeastOneField } // Adiciona a validação personalizada
    );
    
  }

  requireAtLeastOneField(group: any): { [key: string]: boolean } | null {
    const email = group.controls.email.value;
    const telefone = group.controls.telefone.value;
  
    if (!email && !telefone) {
      return { atLeastOneRequired: true }; // Retorna erro se ambos estiverem vazios
    }
    return null; // Retorna válido se pelo menos um estiver preenchido
  }
  

  public validate: boolean = false;

  public submit() {

    //this.validate = !this.validate;
    console.log(this.realDeskForm.value);
    this.isLoading = true;

    this.http.post<any>(`${environment.apiUrl}/clients`, this.realDeskForm.value ).subscribe(
      (response) => {
        console.log(response);
        this.isLoading = false;
           this.modal.close(response);
      },
      (error) => {
        console.error('Error:', error);
        this.isLoading = false;
      });
  }


  public closeModal() {
    this.modal.close(null);
  }	
}
